import { Navigate, useMatch, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import routes from "../../../routes";
import AuthService from "../../../services/auth-service/AuthService";
import { useMountBreadCrumb } from "../../../hooks/useMountBreadCrumb";
import { DefaultLayout } from "../../../layouts";
import Storage from "../../../services/storage-service/Storage";
import Theme from "../../../layouts-v2/full-layout/customizer/Theme";
const validateRoute = (matchPath, children, route) => {
    const decodedToken = AuthService.getDecodedToken();
    const userScopes = decodedToken ? decodedToken.scopes : null;
    const path = matchPath;
    const scopes = routes.find(route => route.path === path).requiredScopes;
    const { setBreadCrumb } = useMountBreadCrumb();
    if (!route.hasBreadCrumb) {
        setBreadCrumb(null);
    }

    if (scopes.length > 0) {
        const findedScopes = userScopes.filter(scope => scopes.includes(scope));
        const hasScope = scopes.length === findedScopes.length;
        if (!hasScope) {
            return <Navigate to="/applications/1" replace />;
        }
    }

    if (route.hideSidebar) {
        return <Theme>{children}</Theme>;
    }

    return <DefaultLayout>{children}</DefaultLayout>;
};

const WrappedRoute = ({ children, path, isPrivate, route }) => {
    const match = useMatch(path);
    const matchPath = match.pattern.path;
    const isAuthenticated = AuthService.isAuthenticated();
    const location = useLocation(path);
    const queryParams = location?.search || "";

    if (queryParams.includes("loginType=")) {
        Storage.setInSession(Storage.KEYS.CREDENTIAL_LOGIN_TYPE, queryParams);
    }

    if (queryParams.includes("cli_login=true")) {
        Storage.setInSession(Storage.KEYS.CLI_LOGIN_PARAMS, queryParams);
    }

    const hasLoginType =
        queryParams.includes("loginType=") ||
        queryParams.includes("cli_login=true");
    if (isAuthenticated && hasLoginType) {
        return <Navigate to="/settings/generate-credential" />;
    }

    if (!isAuthenticated && !isPrivate) {
        return <>{children}</>;
    }

    if (!isAuthenticated && path !== "/" && isPrivate) {
        return <Navigate to="/" replace />;
    }

    if (
        process.env.REACT_APP_ENV === "production" &&
        route.path === "/persistere/:slug/listAll"
    ) {
        return <Navigate to="/applications/1" replace />;
    }

    return validateRoute(matchPath, children, route);
};

WrappedRoute.propTypes = {
    location: PropTypes.object,
    component: PropTypes.any,
    match: PropTypes.any
};

export default WrappedRoute;
